module.exports = __webpack_public_path__ + "static/media/truck-monster.4eb9113f.svg";